import React from "react";
import { Badge, BadgeProps } from "@mantine/core";

import "./EBadge.scss";

export const EBadge = (props: BadgeProps) => {
  return (
    <Badge
      color={props.color ?? "blue"}
      variant={props.variant ?? "filled"}
      {...props}
    />
  );
}